export default __webpack_public_path__ + "static/media/nft_up_white.b9d7018a.svg";